import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Allocate extends Component {

    constructor() {
        super();
        this.state = {
            objs: [],
            objsload: false,

            urlorder:'',
            urlallocate:'',
            //modal
            showmore: false,
            selectedallocate: "-1",
        }
    }
    async componentDidMount() {
       this.fetcheddata()
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    showmore = (event,id) => {
        event.preventDefault()
        this.setState({
            showmore: true,
            selectedallocate: id,
        })
    }
    hidemore = () => {
        this.setState({
            showmore:false,
        })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    fetcheddata = () => {
        let baseurl = myconfig.getobjallocate;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let order_id = new URLSearchParams(this.props.location.search).get("order_id");
        this.setState({
            objs: [],
            objsload: false,
            urlorder: myconfig.order + "?sid=" + sid + "&user=" + user,
        })
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
            "order_id": order_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                if (res.data.isfound) {
                    this.setState({
                        objs: res.data,
                        objsload: true,
                        urlordercreate: myconfig.ordercreate + "&sid=" + sid + "&user=" + user,
                        urlorderupdate: myconfig.orderupdate + "&sid=" + sid + "&user=" + user,
                        urlallocate: myconfig.allocatecu + "?sid=" + sid + "&user=" + user,
                    })
                } else {
                    var win = window.open(this.state.urlorder, "_self");
                }
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    allocatetable = () => {
        let retdata = null;
        if (this.state.objsload) {
            let count = 0;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            retdata = this.state.objs.datas.map(value => {
                count = count + 1
                let url=myconfig.allocatecu + "?sid=" + sid + "&user=" + user+ "&allocate_id=" + value.id+ "&order_id=" + value.order_id
                return (<tr>
                    <td>{count}</td>
                    <td>
                        <a href="#" onClick={(event => this.showmore(event,value.id))}> More </a> |
                        <a href={url}> Allocate </a>
                    </td>
                    <td>{value.tran_name}</td>
                    <td>{value.tran_type}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.loadedweight}</td>
                    <td>{value.loc_full_name}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    render() {
        let orderinfo=null;
        if(this.state.objsload) {
            orderinfo = (
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Route: </span>
                            <label><strong>{this.state.objs.order.orgdes}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Order Date: </span>
                            <label><strong>{this.state.objs.order.orderdate}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Volume: </span>
                            <label><strong>{this.state.objs.order.volume}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Customer: </span>
                            <label><strong>{this.state.objs.order.client}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Cargo: </span>
                            <label><strong>{this.state.objs.order.cargo_id}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Distance: </span>
                            <label><strong>{this.state.objs.order.distance}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Fuel Empty: </span>
                            <label><strong>{this.state.objs.order.fuelempty}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Fuel Load: </span>
                            <label><strong>{this.state.objs.order.fuelload}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Per Diem Empty: </span>
                            <label><strong>{this.state.objs.order.perdiemempty}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Per Diem Loaded: </span>
                            <label><strong>{this.state.objs.order.allowancloaded}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Handel Fee Empty: </span>
                            <label><strong>{this.state.objs.order.handlinefeeempty}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Handel Fee Load: </span>
                            <label><strong>{this.state.objs.order.handlinefeeloaded}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Total: </span>
                            <label><strong>{this.state.objs.order.total}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Assigned: </span>
                            <label><strong>{this.state.objs.order.assigned}</strong></label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>Not-Assigned: </span>
                            <label><strong>{this.state.objs.order.notassigned}</strong></label>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <>
                <Nav type="oordermgt"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Allocation Management</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Order List</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                    <input type="text" name="table_search"
                                                           className="form-control float-right" placeholder="Search"/>
                                                    <div className="input-group-append">
                                                        <button type="submit" className="btn btn-default">
                                                            <i className="fas fa-search"/>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-body pb-3">
                                            {orderinfo}
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Action</th>
                                                    <th>Transporter Name</th>
                                                    <th>Type</th>
                                                    <th>Truck</th>
                                                    <th>Status</th>
                                                    <th>Driver Name</th>
                                                    <th>Phone #</th>
                                                    <th>Trailer #</th>
                                                    <th>Allocate Date</th>
                                                    <th>Load Date</th>
                                                    <th>Offload Date</th>
                                                    <th>Load Weight</th>
                                                    <th>Trip Start</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.allocatetable()}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Allocate;
